import React from 'react';
import { Home, Music, Camera, Wifi, Settings, Video } from 'lucide-react';
const ServicesDetailSection = () => {
  const services = [{
    icon: <Home className="w-10 h-10" data-id="element-284" />,
    title: 'Home Theater Installations',
    description: 'Custom-designed home theater systems with premium audio and visual components, professionally installed for an immersive entertainment experience.',
    features: ['4K/8K Projectors', 'Surround Sound', 'Whole Home Audio', 'Smart Controls']
  }, {
    icon: <Music className="w-10 h-10" data-id="element-285" />,
    title: 'Commercial Audio Systems',
    description: 'High-quality audio solutions for businesses, restaurants, and retail spaces designed to enhance customer experience and employee productivity.',
    features: ['Multi-Zone Audio', 'Background Music', 'Paging Systems', 'Legal Music Solutions']
  }, {
    icon: <Camera className="w-10 h-10" data-id="element-286" />,
    title: 'Camera Systems & Access Control',
    description: 'Comprehensive HD camera systems, smart doorbells, and electronic access control for homes and businesses.',
    features: ['4K Surveillance', 'No required monthly fees', 'Smart Doorbell', 'Access Control']
  }, {
    icon: <Wifi className="w-10 h-10" data-id="element-287" />,
    title: 'WiFi & Network Solutions',
    description: 'Enterprise-grade networking infrastructure with certified UniFi installations, ensuring reliable and secure connectivity throughout your property.',
    features: ['Mesh Networks', 'UniFi & Eero Specialist', 'Remote Management', 'Safety Setup']
  }, {
    icon: <Settings className="w-10 h-10" data-id="element-288" />,
    title: 'Smart Home Programming',
    description: 'Custom programming for URC, Sonos, and other smart home systems to create seamless automation and control experiences.',
    features: ['Voice Control', 'Custom Scenes', 'Mobile App', 'Remote Support']
  }, {
    icon: <Video className="w-10 h-10" data-id="element-289" />,
    title: 'Video Distribution',
    description: 'Multi-room video distribution systems allowing you to share content across multiple displays throughout your property.',
    features: ['4K Distribution', 'Streaming Integration', 'Matrix Switching', 'Control Systems']
  }];
  return <section id="services-section" className="py-16 md:py-24 bg-gray-50" data-id="element-290">
      <div className="container mx-auto px-4" data-id="element-291">
        <div className="text-center mb-16" data-id="element-292">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-293">OUR SERVICES</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-294">
            Comprehensive I75 Audio & Video, LLC & Smart Technology Solutions
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-295">
            From home theaters and commercial audio to camera systems and
            networking, our team delivers end-to-end solutions tailored to your
            specific needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-296">
          {services.map((service, index) => <div key={index} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow p-6 flex flex-col h-full" data-id="element-297">
              <div className="text-blue-600 mb-4" data-id="element-298">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3" data-id="element-299">{service.title}</h3>
              <p className="text-gray-600 mb-6 flex-grow" data-id="element-300">
                {service.description}
              </p>
              <div className="mt-auto" data-id="element-301">
                <h4 className="font-semibold text-gray-800 mb-2" data-id="element-302">
                  Key Features:
                </h4>
                <ul className="space-y-1" data-id="element-303">
                  {service.features.map((feature, idx) => <li key={idx} className="flex items-center text-gray-600" data-id="element-304">
                      <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-305">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-306" />
                      </svg>
                      {feature}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ServicesDetailSection;